import { Popover, PopoverContent, PopoverTrigger } from './popover';
import { Calendar } from './calendar';
import { Label } from './label';
import { FormControl } from './form';
import { Button } from './button';
import { cn } from '@/lib/utils';
import { FieldValues } from 'react-hook-form';
import { format } from 'date-fns';
import { CalendarIcon } from 'lucide-react';

const DateInput = ({
  datePickerOpen,
  setDatePickerOpen,
  field,
  label,
  placeholder,
  required,
  disabledTime,
}: {
  datePickerOpen: boolean;
  setDatePickerOpen: (open: boolean) => void;
  field: FieldValues;
  label: string;
  placeholder?: string;
  required?: boolean;
  disabledTime?: (date: Date) => boolean;
}) => {
  return (
    <>
      <Label required={required} className="luxury-label">
        {label}
      </Label>
      <Popover open={datePickerOpen} onOpenChange={setDatePickerOpen}>
        <PopoverTrigger asChild>
          <FormControl>
            <Button
              variant={'outline'}
              className={cn(
                'w-full pl-3 text-left font-normal border-luxury-200 hover:bg-luxury-50 hover:text-luxury-900 bg-white',
                !field.value && 'text-muted-foreground'
              )}
            >
              {field.value ? (
                format(field.value, 'dd/MM/yyyy')
              ) : (
                <span>{placeholder}</span>
              )}
              <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
            </Button>
          </FormControl>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 border-luxury-200" align="start">
          <Calendar
            mode="single"
            selected={field.value}
            onSelect={(date) => {
              field.onChange(date);
              setDatePickerOpen(false);
            }}
            disabled={disabledTime}
            initialFocus
            className="rounded-md border-luxury-200"
          />
        </PopoverContent>
      </Popover>
    </>
  );
};

export default DateInput;
